<template>
  <v-card v-if="driver">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Images") }}</h3>
    </v-btn>

    <v-row style="padding: 10px 10px">
      <v-container class="fill-height" fluid>
        <v-fade-transition mode="out-in">
          <v-row key="0">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="4"
              v-for="(picture, index) in driver.driverDetail.pictures"
              :key="index"
            >
              <v-card>
                <z-confirm-button
                  fab
                  color="red"
                  x-small
                  class="close-button"
                  :message="$i18n.t('Remove Image ?')"
                  @click="removePic(index)"
                  text
                  dark
                >
                  <v-icon>mdi-close</v-icon>
                </z-confirm-button>
                <a :href="picture.url">
                  <v-img
                    v-if="isPDF(picture.url)"
                    src="@/assets/pdf_format.png"
                    aspect-ratio="2"
                    class="grey darken-4"
                  ></v-img>
                  <v-img
                    v-else
                    :src="picture.url"
                    aspect-ratio="2"
                    class="grey darken-4"
                  ></v-img>
                </a>
                <v-row class="px-2">
                  <v-col cols="12" md="12" lg="12">{{ picture.name }}</v-col>
                  <v-col cols="12" md="12" lg="12"
                    >{{ picture.desc }}{{ picture.by }}
                    {{ picture.time | moment("HH:mm DD MMM YYYY") }}</v-col
                  >
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-fade-transition>
      </v-container>
    </v-row>
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-file-input
          chips
          :label="$i18n.t('Attachment')"
          @change="handleImageUpload()"
          v-model="imageFile"
        ></v-file-input>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-select
          :items="imageNames"
          v-model="imageName"
          item-text="name"
          item-value="value"
        ></v-select>
      </v-col>

      <v-col cols="12" sm="12" md="3" lg="2">
        <br />
        <v-btn
          v-if="imageFile"
          color="purple lighten-2"
          small
          v-on:click="uploadImage"
        >
          <h3>{{ $i18n.t("Upload") }}</h3>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Pictures",
  props: {
    value: {
      default: null,
    },
  },
})
export default class Pictures extends Vue {
  driver = null;

  get loading() {
    return common.loading;
  }

  @Watch("value")
  onValueChange(newVal) {
    this.driver = newVal;
  }

  async mounted() {
    if (this.value) this.driver = this.value;

    if (!this.driver) this.driver = {};
    if (!this.driver.driverDetail) this.driver.driverDetail = {};
    if (!this.driver.driverDetail.pictures)
      this.driver.driverDetail.pictures = [];
  }

  imageNames = [
    { name: "Driver Pic", value: "Driver Pic" },
    { name: "Driving License", value: "Driving License" },
    { name: "Aadhar", value: "Aadhar" },
    { name: "Other", value: "Other" },
  ];

  // Image Upload Start
  imageFile = null;
  handleImageUpload(files) {
    if (files) {
      this.imageFile = files[0];
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  imageName = "Driver Pic";
  async uploadImage() {
    try {
      common.setLoading(true);
      const formData = new FormData();

      if (this.id) {
        formData.set("_id", this.driver._id);
        formData.set("name", this.imageName);
      }
      if (this.isSet(this.imageFile)) {
        formData.append("file", this.imageFile);
      }
      const url = "/api/driver/" + this.driver._id + "/picture/save";
      await doPostForm(url, formData);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      this.$emit("reload", true);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
  // Image Upload End

  async removePic(index) {
    if (this.driver.driverDetail.pictures[index].url == null) {
      this.driver.driverDetail.pictures.splice(index, 1);
    } else {
      common.setLoading(true);
      const time = this.driver.driverDetail.pictures[index].time;
      try {
        await doGet(
          "/api/driver/" + time + "/" + this.driver._id + "/delete/picture"
        );
        common.setLoading(false);
        common.showMessage("Saved Successfully");
        this.$emit("reload", true);
      } catch (e) {
        common.setLoading(false);
        common.setError(e.message);
      }
    }
  }

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>
